const oldModel = ['Сотрудник', 'Вопрос', 'Руководитель', 'Решение', 'Сотрудник выполняет'];
const newModel = ['Сотрудник', 'Анализ ситуации', 'Варианты решения', 'Предложение', 'Решение в рамках полномочий'];

const role = [
  'задавать рамки — определять границы, внутри которых сотрудник может действовать самостоятельно;',
  'определять полномочия — что сотрудник решает сам, а что согласовывает;',
  'обучать сотрудников принимать решения — передавать не только задачи, но и логику принятия решений;',
  'не забирать задачу обратно после первой ошибки — иначе самостоятельность так и не сформируется;',
  'использовать ошибки как материал для развития — разбирать их без обвинений и с выводом на действия;',
  'устанавливать контрольные точки — проверять результат на ключевых этапах, а не каждый шаг.',
];

export default function TeamAutonomy() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-6xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-3">
          Как перестать быть единственным человеком, который принимает решения
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Как руководителю повысить самостоятельность команды, не теряя контроль над результатом
        </p>

        <div className="grid md:grid-cols-2 gap-6 mb-12">
          <div className="bg-white rounded-2xl border border-gray-200 p-6 md:p-8">
            <h3 className="text-base font-bold text-gray-900 mb-4">Типичная ситуация</h3>
            <div className="space-y-2">
              {oldModel.map((step, i) => (
                <div key={i} className="flex items-center gap-3">
                  <span className="w-6 h-6 rounded-full bg-gray-200 text-gray-600 flex items-center justify-center text-xs font-bold flex-shrink-0">{i + 1}</span>
                  <span className="text-sm text-gray-700">{step}</span>
                </div>
              ))}
            </div>
            <p className="text-xs text-gray-500 mt-4 leading-relaxed">
              Все решения проходят через руководителя, команда ждёт указаний, руководитель перегружен и становится «узким местом».
            </p>
          </div>

          <div className="bg-teal-50 rounded-2xl border border-teal-200 p-6 md:p-8">
            <h3 className="text-base font-bold text-teal-900 mb-4">Более эффективная модель</h3>
            <div className="space-y-2">
              {newModel.map((step, i) => (
                <div key={i} className="flex items-center gap-3">
                  <span className="w-6 h-6 rounded-full bg-teal-600 text-white flex items-center justify-center text-xs font-bold flex-shrink-0">{i + 1}</span>
                  <span className="text-sm text-teal-900">{step}</span>
                </div>
              ))}
            </div>
            <p className="text-xs text-teal-800 mt-4 leading-relaxed">
              Сотрудник анализирует ситуацию, предлагает варианты и принимает решение в рамках своих полномочий. Руководитель управляет результатом, а не каждым шагом.
            </p>
          </div>
        </div>

        <div className="bg-white rounded-2xl border border-gray-200 p-6 md:p-8 max-w-4xl mx-auto">
          <h3 className="text-lg font-bold text-gray-900 mb-4">Роль руководителя в развитии самостоятельности</h3>
          <div className="space-y-2.5">
            {role.map((r, i) => (
              <div key={i} className="flex items-start gap-2.5">
                <i className="ri-checkbox-circle-line text-teal-600 mt-0.5 flex-shrink-0"></i>
                <span className="text-sm text-gray-700 leading-relaxed">{r}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}